import { useEffect, useState } from "react";
import {
  addStakeholderContactClinic,
  GetDoctorDetails,
  GetStakeholderContactClinicInfo,
  searchManualZipCode,
  updateStakeholderContactClinic,
} from "../../../../services/StakeholderApi";
import {
  Badge,
  Button,
  Col,
  Container,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import TextInput from "../../../../common/TextInput";
import DataTable from "../../../../common/DataTable";
import {
  CONTACT_LOG_HEADERS,
  STAKEHOLDER_CLINIC_ADDRESS,
  STAKEHOLDERS_CLINIC_CONTACT,
} from "../actions/Constant";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import Snackbar from "../../../../common/Snackbar";
import OverlayDrawer from "../../../../common/OverlayDrawer";
import TagComponent from "../../../../common/TagComponent";
import { validateClinicAddress } from "./stakeholderValidation";
import AccordionComponent from "../../../../common/Accordion";
import SearchableAddressDropdown from "../../../../common/SearchableZipDropdown";
import { getPlaceByAddress } from "../../../../utils/getPlaceByAddress";
import SearchHospitalAutosuggest, { LocationSuggestion } from "../../../../common/SearchHospitalAutosuggest";
import { isValidCoordinate } from "../../../../utils/validators";
import { addMedicareLocation } from "../../../../services/SystemLocationAPI";
import Loader from "../../../../common/Loader";
import { PARTIES_MASTER_ACTIONS } from "../../../../common/EventConstant";
import { PICKLIST_GROUP_NAME } from "../../../../common/Constant";
import { fetchPickListByGroupName } from "../../../../services/CaseInformationApi";
import SearchAutosuggest from "../../../../common/SearchAutosuggestLocations";
import { normalizeCountry, normalizeState } from "../../../../utils/normalizer";

interface HospitalClinicSearchResult {
  areaName: string;
  districtName: string;
  localeName: string;
  physicalCity: string;
  physicalState: string;
  physicalZip: string;
  country: string;
}

const AssociatedClinicForm: React.FC<any> = ({
  stakeholdercontactid,
  activeTab,
  contactName,
  closeForm,
}) => {
  const userID = useSelector((state: RootState) => state.auth.userid);
  const [searchQuery, setSearchQuery] = useState<any>("");
  const [suggestionSelected, setSuggestionSelected] = useState(false);
  const [suggestionFilled, setSuggestionFilled] = useState({ city: false, state: false, country: false, zip: false });
  const [addressDetails, setAddressDetails] = useState({
    city: "",
    state: "",
    country: "",
    zip: "",
    medicareId: "",
    providerName: "",
    providerAddress: "",
  });
  const [addressline1, setAddressLine1] = useState("");
  const [clinicemailId, setClinicEmailId] = useState<string[]>([]);
  const [clinicphoneNumber, setClinicPhoneNumber] = useState<string[]>([]);
  const [clinicfaxNumber, setClinicFaxNumber] = useState<string[]>([]);
  const [showForm, setShowForm] = useState(false);
  const [showPreviousClinic, setShowPreviousClinic] = useState(true);
  const [clinicID, setClinicID] = useState<any>(null);
  const [clinicLogs, setClinicLogs] = useState<any[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [clinicIDtoUpdate, setClinicIDToUpdate] = useState("");

  const [clinicDetails, setClinicDetails] = useState<any[]>([]);
  const [contactLocationName, setContactLocationName] = useState("");

  const [isManualEntry, setIsManualEntry] = useState(false);
  const [manualLocation, setManualLocation] = useState("");
  const [manualAddress, setManualAddress] = useState("");
  const [manualCity, setManualCity] = useState("");
  const [manualState, setManualState] = useState("");
  const [manualCountry, setManualCountry] = useState("");
  const [manualZip, setManualZip] = useState("");
  const [isManualLocation, setIsManualLocation] = useState(false);

  const [cityOptions, setCityOptions] = useState<string[]>([]);
  const [stateOptions, setStateOptions] = useState<string[]>([]);
  const [countryOptions, setCountryOptions] = useState<string[]>([]);
  const [zipOptions, setZipOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [pendingGoogleLocation, setPendingGoogleLocation] = useState<any>(null);

  const [instructionOption, setInstructionOption] = useState<
    { value: string; label: string }[]
  >([]);

  const params = {
    location: {
      groupName: PICKLIST_GROUP_NAME.Location_SplInstructions,
      triggerById: userID,
    },
  };

  const fetchCategoryData = async () => {
    try {
      const categoryData = await fetchPickListByGroupName(params.location);

      setInstructionOption(categoryData || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (userID) fetchCategoryData();
  }, [userID]);

  const allowedFeatures = useSelector(
    (state: RootState) => state.featureAccess.allowedFeatures,
  );

  const editContact = allowedFeatures.has(PARTIES_MASTER_ACTIONS.CONTACT_EDIT);

  const fetchData = async () => {
    try {
      const data = await GetStakeholderContactClinicInfo(stakeholdercontactid);

      setClinicDetails(data || []); // <-- Update contactData state
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (stakeholdercontactid) {
      fetchData();
    }
  }, [stakeholdercontactid]);

  const handleSuggestionSelect = (suggestion: LocationSuggestion) => {
    const newStateCode = suggestion.physicalStateCode || normalizeState(suggestion.physicalState || "");
    const newCountryCode = normalizeCountry(suggestion.countryCode || suggestion.country || "USA");

    if (suggestion.source === "google") {
      setPendingGoogleLocation({
        source: "google",
        providerName: suggestion.providerName,
        providerAddress: suggestion.providerAddress,
        physicalCity: suggestion.physicalCity,
        physicalState: newStateCode,
        physicalZip: suggestion.physicalZip,
        countryName: newCountryCode,
        county: suggestion.county,
        areaName: suggestion.areaName || "",
        latitude: isValidCoordinate(suggestion.latitude) ? String(suggestion.latitude) : "",
        longitude: isValidCoordinate(suggestion.longitude) ? String(suggestion.longitude) : "",
      });
    } else {
      setPendingGoogleLocation(null);
    }
    setSuggestionSelected(true);
    setSuggestionFilled({
      city: !!suggestion.physicalCity,
      state: !!newStateCode,
      country: !!newCountryCode,
      zip: !!suggestion.physicalZip,
    });
    setAddressDetails({
      city: suggestion.physicalCity || "",
      state: newStateCode,
      country: newCountryCode,
      zip: suggestion.physicalZip || "",
      medicareId: suggestion.medicareId || "",
      providerName: suggestion.providerName || "",
      providerAddress: suggestion.providerAddress || "",
    });
    setAddressLine1(suggestion.providerAddress || "");
  };

  const handleAddClinic = () => {
    // Reset all states
    setAccosiatedHospitalKey(null);
    resetManualLocationFields();
    setClinicID(null);
    setClinicIDToUpdate("");
    setClinicEmailId([]);
    setSearchQuery("");
    setClinicPhoneNumber([]);
    setClinicFaxNumber([]);
    setAddressLine1("");
    setContactLocationName("");
    setSuggestionSelected(false);
    setSuggestionFilled({ city: false, state: false, country: false, zip: false });
    setAddressDetails({
      city: "",
      state: "",
      country: "",
      zip: "",
      medicareId: "",
      providerName: "",
      providerAddress: "",
    });
    setPendingGoogleLocation(null);
    setShowForm(true);
  };

  const handleEdit = (clinic: any) => {
    setAccosiatedHospitalKey(null);
    resetManualLocationFields();
    setClinicID(clinic);
    setShowForm(true);
    setClinicIDToUpdate(clinic.contactMedicareListId);
    setAddressDetails({
      city: clinic.physicalCity || "",
      state: clinic.physicalState || "",
      country: clinic.countryName || "",
      zip: clinic.physicalZip || "",
      medicareId: clinic.medicareId || "",
      providerName: clinic.providerName || "",
      providerAddress: clinic.providerAddress || "",
    });
    setContactLocationName(clinic.locationContactName);
    setSearchQuery(clinic.providerName);
    setClinicEmailId(
      clinic.emailAddress
        ? clinic.emailAddress.split(",").map((num: string) => num.trim())
        : [],
    );
    setClinicPhoneNumber(
      clinic.phoneNumber
        ? clinic.phoneNumber.split(",").map((num: string) => num.trim())
        : [],
    );
    setClinicFaxNumber(
      clinic.faxNumber
        ? clinic.faxNumber.split(",").map((num: string) => num.trim())
        : [],
    );
  };

  const handleCancel = () => {
    setShowModal(true); // Show confirmation modal
  };

  const handlePDFClick = () => {
    if (clinicID) {
      // Extract the four fields from the selectedContact

      const {
        createdByFullName,
        createdDate,
        modifiedByFullName,
        modifiedDate,
      } = clinicID;

      // Format the date using moment.js
      const formattedCreatedDate =
        moment(createdDate).format("MM/DD/YYYY HH:mm");
      const formattedModifiedDate =
        moment(modifiedDate).format("MM/DD/YYYY HH:mm");

      // Set the values in the state
      setClinicLogs([
        {
          createdByFullName,
          createdDate: formattedCreatedDate, // Use formatted date
          modifiedByFullName,
          modifiedDate: formattedModifiedDate, // Use formatted date
        },
      ]);

      // Show the drawer
      setShowDrawer(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false); // Close modal without resetting form
  };

  const handleCloseDrawer = () => {
    setShowDrawer(false);
  };

  const handleConfirmCancel = () => {
    setIsManualEntry(false);
    setClinicID(null);
    setClinicEmailId([]);
    setSearchQuery("");
    setClinicPhoneNumber([]);
    setClinicFaxNumber([]);
    setAddressLine1("");
    setContactLocationName("");
    setSuggestionSelected(false);
    setSuggestionFilled({ city: false, state: false, country: false, zip: false });
    setAddressDetails({
      city: "",
      state: "",
      country: "",
      zip: "",
      medicareId: "",
      providerName: "",
      providerAddress: "",
    });
    setPendingGoogleLocation(null);
    setShowForm(false);
    setShowModal(false); // Close modal after confirmation
    setAccosiatedHospitalKey("0");
    setAccosiatedCommunicationDetailKey("0");
    resetManualLocationFields();
  };

  const validateClinicForm = () => {
    const validationErrors = validateClinicAddress(
      addressDetails,
      isManualEntry,
      manualAddress,
      manualLocation,
      manualCity,
      manualCountry,
      manualState,
      manualZip,
      clinicemailId,
      clinicphoneNumber,
      clinicfaxNumber,
    );

    if (validationErrors.length > 0) {
      console.log("Setting Snackbar Message:", validationErrors.join("\n"));
      setSnackbarMessage(validationErrors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const handleSave = async () => {
    if (isSaving) return;
    if (validateClinicForm()) {
      setLoading(true);
      try {
        setIsSaving(true);
       
        let fixedLoc: { latitude?: number | null; longitude?: number | null } =
          {};
        if (manualLocation) {
          const addressInDetails = `${manualAddress}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;
          const locationInDetails = `${manualLocation}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;
          const locationFullDetails = `${manualLocation}, ${manualAddress}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;
          const placeResult = await getPlaceByAddress({
            name: locationInDetails,
            address: addressInDetails,
            fullAddress: locationFullDetails,
          });
          if (placeResult) {
            fixedLoc = {
              latitude: placeResult.latitude,
              longitude: placeResult.longitude,
            };
          }
        }

        let splInstructionsPayload: any[] = [];
        splInstructionsPayload = instructionOption.map((opt: any) => ({
          SplInstructionID: opt.value,
          SplInstructionData: "",
        }));

        const useGoogleFallback =
          !isManualEntry &&
          pendingGoogleLocation?.source === "google";

        const basePayload = {
          stakeholderContactId: stakeholdercontactid,
          medicareId: addressDetails?.medicareId || null,
          providerName: useGoogleFallback ? addressDetails?.providerName : manualLocation || addressDetails?.providerName || "",
          providerAddress:
            useGoogleFallback ? addressDetails?.providerAddress : manualAddress || addressDetails?.providerAddress || "",
          physicalCity: useGoogleFallback ? addressDetails?.city : manualCity || addressDetails?.city || "",
          physicalState: useGoogleFallback ? addressDetails?.state : manualState || addressDetails?.state || "",
          physicalZip: useGoogleFallback ? addressDetails?.zip : manualZip || addressDetails?.zip || "",
          countryName: useGoogleFallback ? addressDetails?.country : manualCountry || addressDetails?.country || "",

          emailAddress: clinicemailId.length > 0 ? clinicemailId.join(",") : "",
          phoneNumber:
            clinicphoneNumber.length > 0 ? clinicphoneNumber.join(",") : "",
          faxNumber:
            clinicfaxNumber.length > 0 ? clinicfaxNumber.join(",") : "",
          splInstructions: splInstructionsPayload,
          createdBy: userID,
          locationContactName: contactLocationName,
        };
        const baseUpdatePayload = {
          stakeholderContactId: stakeholdercontactid,
          contactMedicareListId: clinicIDtoUpdate,
          medicareId: isManualEntry ? null : addressDetails?.medicareId || null,

          providerName: useGoogleFallback ? addressDetails?.providerName : manualLocation || addressDetails?.providerName || "",
          providerAddress:
            useGoogleFallback ? addressDetails?.providerAddress : manualAddress || addressDetails?.providerAddress || "",
          physicalCity: useGoogleFallback ? addressDetails?.city : manualCity || addressDetails?.city || "",
          physicalState: useGoogleFallback ? addressDetails?.state : manualState || addressDetails?.state || "",
          physicalZip: useGoogleFallback ? addressDetails?.zip : manualZip || addressDetails?.zip || "",
          countryName: useGoogleFallback ? addressDetails?.country : manualCountry || addressDetails?.country || "",
          emailAddress: clinicemailId.length > 0 ? clinicemailId.join(",") : "",
          phoneNumber:
            clinicphoneNumber.length > 0 ? clinicphoneNumber.join(",") : "",
          faxNumber:
            clinicfaxNumber.length > 0 ? clinicfaxNumber.join(",") : "",
          splInstructions: splInstructionsPayload,
          createdBy: userID,
          locationContactName: contactLocationName,
        };
        const payloadAdd = {
          ...basePayload,
          ...(useGoogleFallback && {
            latitude: String(pendingGoogleLocation.latitude),
            longitude: String(pendingGoogleLocation.longitude),
          }),
          ...(!useGoogleFallback &&
            manualLocation &&
            isValidCoordinate(fixedLoc?.latitude) &&
            isValidCoordinate(fixedLoc?.longitude) && {
              latitude: String(fixedLoc.latitude),
              longitude: String(fixedLoc.longitude),
            }),
        };
        const payloadUpdate = {
          ...baseUpdatePayload,
          ...(useGoogleFallback && {
            latitude: String(pendingGoogleLocation.latitude),
            longitude: String(pendingGoogleLocation.longitude),
          }),
          ...(!useGoogleFallback &&
            manualLocation &&
            isValidCoordinate(fixedLoc?.latitude) &&
            isValidCoordinate(fixedLoc?.longitude) && {
              latitude: String(fixedLoc.latitude),
              longitude: String(fixedLoc.longitude),
            }),
        };
        const isUpdate = clinicID ? true : false;

        const apiMethod = isUpdate
          ? updateStakeholderContactClinic
          : addStakeholderContactClinic;

        const response = await apiMethod(isUpdate ? payloadUpdate : payloadAdd);
        const successMessage = isUpdate
          ? "Location updated successfully."
          : "Location added successfully.";
        if (response.result.responseCode == 1) {
          setSnackbarMessage(successMessage);
          setError("success");
          setSnackbarOpen(true);
          setShowForm(false);
          setSearchQuery("");
          setAccosiatedHospitalKey("0");
          setAccosiatedCommunicationDetailKey("0");
          resetManualLocationFields();
          fetchData();
        } else if (response.result.responseCode == 2) {
          setSnackbarMessage("This clinic is already added for this contact.");
          setError("error");
          setSnackbarOpen(true);
        } else {
          setSnackbarMessage("Failed to add or update contact");
          setError("error");
          setSnackbarOpen(true);
        }
      } catch (error) {
        console.error("Error while saving clinic location:", error);
        setSnackbarMessage("An unexpected error occurred.");
        setError("error");
        setSnackbarOpen(true);
      } finally {
        setLoading(false);
        setIsSaving(false);
      }
    }
  };

  const closeContactForm = () => {
    closeForm();
  };

  const [AccosiatedHospitalKey, setAccosiatedHospitalKey] = useState<
    string | null
  >("0");

  const AccosiatedHospitalAccordion = (
    items: { title: JSX.Element; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={AccosiatedHospitalKey}
      onSelect={(key) => setAccosiatedHospitalKey(key as string)}
    />
  );

  const [AccosiatedHospitalDetailKey, setAccosiatedHospitalDetailKey] =
    useState<string | null>("0");

  const AccosiatedHospitalDetailAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={AccosiatedHospitalDetailKey}
      onSelect={(key) => setAccosiatedHospitalDetailKey(key as string)}
    />
  );

  const [AccosiatedClinicDetailKey, setAccosiatedClinicDetailKey] = useState<
    string | null
  >("0");

  const AccosiatedClinicDetailAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={AccosiatedClinicDetailKey}
      onSelect={(key) => setAccosiatedClinicDetailKey(key as string)}
    />
  );
  const [
    AccosiatedClinicCommunicationKey,
    setAccosiatedCommunicationDetailKey,
  ] = useState<string | null>("0");

  const AccosiatedCommuincationDetailAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={AccosiatedClinicCommunicationKey}
      onSelect={(key) => setAccosiatedCommunicationDetailKey(key as string)}
    />
  );

  const handleEnterNewLocation = () => {
    setIsManualEntry(true);
    setIsManualLocation(false);
    setAddressDetails({
      city: "",
      state: "",
      country: "",
      zip: "",
      medicareId: "",
      providerName: "",
      providerAddress: "",
    });
  };

  const [searchResults, setSearchResults] = useState<
    HospitalClinicSearchResult[]
  >([]);

  const handleSearch = async (query: string) => {
    try {
      // Optional: setLoading(true);

      const response = await searchManualZipCode({
        SearchString: query,
        pageNo: 0,
        pageSize: 0,
        sortColumn: "",
        sortOrder: "",
      });

      const results: HospitalClinicSearchResult[] = response?.result || [];

      if (results.length > 0) {
        setSearchResults(results);

        const cities = [
          ...new Set(results.map((r) => r.physicalCity).filter(Boolean)),
        ];
        const zips = [
          ...new Set(results.map((r) => r.physicalZip).filter(Boolean)),
        ];
        const states = [
          ...new Set(results.map((r) => r.physicalState).filter(Boolean)),
        ];
        const countries = [
          ...new Set(results.map((r) => r.country).filter(Boolean)),
        ];

        setCityOptions(cities);
        setZipOptions(zips);
        setStateOptions(states);
        setCountryOptions(countries);

        // Clear only if selected value is no longer valid
        if (!cities.includes(manualCity)) setManualCity("");
        if (!zips.includes(manualZip)) setManualZip("");
        if (!states.includes(manualState)) setManualState("");
        if (!countries.includes(manualCountry)) setManualCountry("");
      }
    } catch (error) {
      console.error("Error searching clinic data:", error);
    } finally {
      // Optional: setLoading(false);
    }
  };

  // Update dropdown options from unfiltered searchResults
  useEffect(() => {
    const cities = [
      ...new Set(searchResults.map((r) => r.physicalCity).filter(Boolean)),
    ];
    const states = [
      ...new Set(searchResults.map((r) => r.physicalState).filter(Boolean)),
    ];
    const countries = [
      ...new Set(searchResults.map((r) => r.country).filter(Boolean)),
    ];
    const zips = [
      ...new Set(searchResults.map((r) => r.physicalZip).filter(Boolean)),
    ];

    setCityOptions(cities);
    setStateOptions(states);
    setCountryOptions(countries);
    setZipOptions(zips);
  }, [searchResults]);

  useEffect(() => {
    if (!manualCity && !manualZip) return;

    let filtered = [...searchResults];

    if (manualCity?.trim()) {
      filtered = filtered.filter(
        (item) =>
          item.physicalCity?.toLowerCase() === manualCity.trim().toLowerCase(),
      );
    }

    if (manualZip?.trim()) {
      filtered = filtered.filter(
        (item) =>
          item.physicalZip?.toLowerCase() === manualZip.trim().toLowerCase(),
      );
    }

    const cities = [
      ...new Set(filtered.map((r) => r.physicalCity).filter(Boolean)),
    ];
    const zips = [
      ...new Set(filtered.map((r) => r.physicalZip).filter(Boolean)),
    ];
    const states = [
      ...new Set(filtered.map((r) => r.physicalState).filter(Boolean)),
    ];
    const countries = [
      ...new Set(filtered.map((r) => r.country).filter(Boolean)),
    ];

    setCityOptions(cities);
    setZipOptions(zips);
    setStateOptions(states);
    setCountryOptions(countries);

    if (cities.length === 1 && !manualCity) setManualCity(cities[0]);
    if (zips.length === 1 && !manualZip) setManualZip(zips[0]);
    if (states.length === 1 && !manualState) setManualState(states[0]);
    if (countries.length === 1 && !manualCountry)
      setManualCountry(countries[0]);
  }, [manualCity, manualZip, searchResults]);

  const resetManualLocationFields = () => {
    setIsManualEntry(false);
    setManualLocation("");
    setManualAddress("");
    setManualCity("");
    setManualState("");
    setManualCountry("");
    setManualZip("");
    setCityOptions([]);
    setStateOptions([]);
    setCountryOptions([]);
    setZipOptions([]);
  };

  const handleMapAction = async (row: any) => {
    const data = await GetDoctorDetails(row);
    const rawLocationJson = data?.associatedLocations || [];
    const locationList: Location[] = rawLocationJson.map((loc: any) => ({
      fax: loc?.faxnumber || "NA",
      phone: loc?.phonenumber || "NA",
      email: loc?.emailaddress || "NA",
      locationname: loc?.locationname || "NA",
      locationaddress: loc?.locationaddress || "NA",
      latitude: loc?.latitude || null,
      longitude: loc?.longitude || null,
    }));

    if (locationList?.length > 0) {
      sessionStorage.removeItem("selectedMapData");
      sessionStorage.setItem(
        "selectedMapData",
        JSON.stringify({
          locations: locationList,
          tab: "QME Schedule",
        }),
      );
      window.open("/#/map/associated_locations", "_blank");
    } else {
      console.error("No associated locations found.");
    }
  };

  const handleSingleMapAction = async (row: any) => {
    const locationList = [
      {
        fax: row?.faxNumber || "NA",
        phone: row?.telephoneNumber || "NA",
        email: row?.emailId || "NA",
        locationname: row?.providerName || "NA",
        locationaddress: [
          row?.providerAddress,
          row?.physicalCity,
          row?.physicalState,
          row?.physicalZip,
          row?.countryName,
        ]
          ?.filter(Boolean)
          .join(", "),
        latitude: row?.latitude || null,
        longitude: row?.longitude || null,
      },
    ];

    if (locationList?.length > 0) {
      sessionStorage.removeItem("selectedMapData");
      sessionStorage.setItem(
        "selectedMapData",
        JSON.stringify({
          locations: locationList,
          tab: "QME Schedule",
        }),
      );
      window.open("/#/map/associated_locations", "_blank");
    } else {
      console.error("No associated locations found for this doctor.");
    }
  };

  const handleAddressSuggestionSelect = async (suggestion: any) => {
    setIsManualLocation(false);
    setManualAddress(suggestion.providerAddress || "");
    setManualLocation(suggestion.providerName || "");

    const suggestedZip = suggestion.physicalZip || "";
    const newStateCode = normalizeState(suggestion.physicalState);
    const newCountryCode = normalizeCountry(suggestion.country || "USA");
    if (suggestion.physicalCity) setManualCity(suggestion.physicalCity);
    if (suggestion.physicalState) setManualState(newStateCode);
    if (suggestion.country) setManualCountry(newCountryCode);
    if (suggestion.physicalCity) setCityOptions([suggestion.physicalCity]);
    if (newStateCode) setStateOptions([newStateCode]);
    if (newCountryCode) setCountryOptions([newCountryCode]);

    if (suggestedZip) {
      setManualZip(suggestedZip);
      setZipOptions([suggestedZip]);

      try {
        const response = await searchManualZipCode({
          SearchString: suggestedZip,
          pageNo: 0,
          pageSize: 10,
          sortColumn: "",
          sortOrder: "",
        });

        const results = response?.result || [];

        if (results.length > 0) {
          const typedResults = results as HospitalClinicSearchResult[];
          const cities = [
            ...new Set(typedResults.map((r) => r.physicalCity).filter(Boolean)),
          ] as string[];
          const zips = [
            ...new Set(typedResults.map((r) => r.physicalZip).filter(Boolean)),
          ] as string[];
          const states = [
            ...new Set(
              typedResults.map((r) => r.physicalState).filter(Boolean),
            ),
          ] as string[];
          const countries = [
            ...new Set(typedResults.map((r) => r.country).filter(Boolean)),
          ] as string[];

          setCityOptions(cities);
          setZipOptions(zips);
          setStateOptions(states);
          setCountryOptions(countries);
        }
      } catch (error) {
        console.error("Zip lookup failed, using suggestion values:", error);
      }
    }
  };

  const handleManualLocationAdd = () => {
    setIsManualLocation(true);
    setManualLocation("");
    setManualAddress("");
    setManualCity("");
    setManualState("");
    setManualZip("");
    setManualCountry("");
  };

  return (
    <>
      {" "}
      <Container fluid className="position-relative mx-0 px-0">
        <Loader isLoading={loading} />
        {showForm && (
          <>
            {AccosiatedHospitalDetailAccordion([
              {
                title: "Location Details",
                content: (
                  <>
                    {AccosiatedClinicDetailAccordion([
                      {
                        title: "Details",
                        content: (
                          <>
                            {!isManualEntry && (
                              <>
                                <Row className="row mb-3">
                                  <Col md={12}>
                                    <SearchHospitalAutosuggest
                                      value={searchQuery}
                                      onChange={setSearchQuery}
                                      onSuggestionSelect={handleSuggestionSelect}
                                      onEnterNewLocation={handleEnterNewLocation}
                                      showEnterNewLocation={true}
                                      label="Location"
                                      required
                                      disabled={!editContact}
                                      maxLength={50}
                                    />
                                  </Col>
                                </Row>

                                <Row className="row mb-3">
                                  <Col md={12}>
                                    <TextInput
                                      label="Address Line 1"
                                      name="AddressLine1"
                                      value={addressDetails.providerAddress}
                                      disabled
                                      maxLength={100}
                                    />
                                  </Col>
                                </Row>
                                <Row className="row">
                                  {["City", "State", "Country", "Zip"].map(
                                    (field) => {
                                      const value =
                                        addressDetails[
                                          field.toLowerCase() as keyof typeof addressDetails
                                        ];

                                    
                                      const isDisabled = !suggestionSelected || !!suggestionFilled[field.toLowerCase() as keyof typeof suggestionFilled];
                                      return (
                                        <Col md={3} key={field}>
                                          <TextInput
                                            label={field}
                                            name={field}
                                            value={value}
                                            maxLength={field === "State" && !isDisabled ? 3 : field === "Zip" && !isDisabled ? 10 : 100}
                                            required
                                            onChange={(e) => {
                                              const newValue = field === "Zip" ? e.target.value.replace(/\D/g, "") : e.target.value;
                                              setAddressDetails((prev: any) => ({ ...prev, [field.toLowerCase()]: newValue }));
                                            }}
                                            disabled={isDisabled}
                                          />
                                        </Col>
                                      );
                                    },
                                  )}
                                </Row>
                              </>
                            )}
                            {isManualEntry && (
                              <>
                                <Row className="row mb-3">
                                  <Col md={12}>
                                    {!isManualLocation ? (
                                      <SearchAutosuggest
                                        value={manualLocation}
                                        onChange={setManualLocation}
                                        onSuggestionSelect={
                                          handleAddressSuggestionSelect
                                        }
                                        onManualLocationAdd={
                                          handleManualLocationAdd
                                        }
                                        enableManualLocation={true}
                                        label="Location"
                                        required
                                        apiKey={
                                          process.env
                                            .REACT_APP_GOOGLE_PLACES_AUTOCOMPLETE_API_KEY
                                        }
                                        countryRestriction="us"
                                        sortingLocation="Location"
                                        maxLength={100}
                                      />
                                    ) : (
                                      <TextInput
                                        label="Location"
                                        name="Location"
                                        value={manualLocation}
                                        onChange={(e) =>
                                          setManualLocation(e.target.value)
                                        }
                                        maxLength={100}
                                        required
                                      />
                                    )}
                                  </Col>
                                </Row>
                                <Row className="row mb-3">
                                  <Col md={12}>
                                     <TextInput
                                        label="Address Line 1"
                                        name="Address Line 1"
                                        value={manualAddress}
                                        onChange={(e) =>
                                          setManualAddress(e.target.value)
                                        }
                                        maxLength={100}
                                        required
                                      />
                                  </Col>
                                </Row>
                                <Row className="mb-3 mt-3 loc-details">
                                  <Col md={3}>
                                    <SearchableAddressDropdown
                                      label="City"
                                      value={manualCity}
                                      options={cityOptions}
                                      onSearch={handleSearch}
                                      onSelect={(val) => setManualCity(val)}
                                      required={true}
                                      disabled={!isManualLocation}
                                    />
                                  </Col>
                                  <Col md={3}>
                                    <SearchableAddressDropdown
                                      label="State"
                                      value={manualState}
                                      options={stateOptions}
                                      onSearch={handleSearch}
                                      onSelect={(val) => setManualState(val)}
                                      required={true}
                                      disabled={
                                        (!manualCity && !manualZip) ||
                                        stateOptions.length === 1 ||
                                        !isManualLocation
                                      }
                                    />
                                  </Col>
                                  <Col md={3}>
                                    <SearchableAddressDropdown
                                      label="Country"
                                      value={manualCountry}
                                      options={countryOptions}
                                      onSearch={handleSearch}
                                      onSelect={(val) => setManualCountry(val)}
                                      required={true}
                                      disabled
                                    />
                                  </Col>
                                  <Col md={3}>
                                    <SearchableAddressDropdown
                                      label="Zip"
                                      value={manualZip}
                                      options={zipOptions}
                                      onSearch={handleSearch}
                                      onSelect={(val) => setManualZip(val)}
                                      required={true}
                                      disabled={!isManualLocation}
                                    />
                                  </Col>
                                </Row>
                              </>
                            )}
                          </>
                        ),
                      },
                    ])}

                    {AccosiatedCommuincationDetailAccordion([
                      {
                        title: "Communication Details",
                        content: (
                          <>
                            <Row>
                              <Col sm={4}>
                                <TextInput
                                  label="Contact Name"
                                  name="contactName"
                                  value={contactLocationName}
                                  onChange={(e) =>
                                    setContactLocationName(e.target.value)
                                  }
                                  maxLength={200}
                                  disabled={!editContact}
                                />
                              </Col>
                              <Col sm={4}>
                                <TagComponent
                                  label="Email ID"
                                  value={clinicemailId}
                                  onChange={setClinicEmailId}
                                  disabled={!editContact}
                                />
                              </Col>
                              <Col sm={4}>
                                <TagComponent
                                  label="Phone Number"
                                  value={clinicphoneNumber}
                                  onChange={(newValues) =>
                                    setClinicPhoneNumber(newValues.map(String))
                                  }
                                  isPhoneOrFax={true}
                                  disabled={!editContact}
                                />
                              </Col>
                              {/* <Col sm={4}>
                                <TagComponent
                                  label="Fax No"
                                  value={clinicfaxNumber}
                                  onChange={(newValues) =>
                                    setClinicFaxNumber(newValues.map(String))
                                  }
                                  isPhoneOrFax={true}
                                  disabled={!editContact}
                                />
                              </Col> */}
                            </Row>
                          </>
                        ),
                      },
                    ])}
                    <Row>
                      <Col sm={6} className="d-flex justify-content-start">
                        {clinicID ? (
                          <OverlayTrigger
                            placement="auto"
                            overlay={
                              <Tooltip style={{ backgroundColor: "#b3e0ff" }}>
                                Logs
                              </Tooltip>
                            }
                          >
                            <Button
                              type="button"
                              className="btn btn-primary d-flex align-items-center mx-2"
                              onClick={handlePDFClick}
                            >
                              <span className="material-icons">
                                description
                              </span>
                            </Button>
                          </OverlayTrigger>
                        ) : null}
                        {/* <button
                          className="btn d-flex align-items-center btn-text-border me-2"
                          onClick={handleConfirmCancel}
                        >
                          <span className="material-icons">arrow_back</span>Back
                        </button> */}
                      </Col>

                      <Col sm={6} className="d-flex  justify-content-end">
                        <Button
                          variant="outline-info"
                          className="d-flex align-items-center"
                          onClick={handleCancel}
                        >
                          <span className="material-icons mr-2">close</span>
                          Cancel
                        </Button>
                        {editContact && (
                          <Button
                            type="submit"
                            variant="primary"
                            className="ms-3 d-flex align-items-center"
                            // disabled={!isEditable || !formik.dirty || formik.isSubmitting}
                            onClick={handleSave}
                            disabled={isSaving}
                          >
                            <span className="material-icons mx-1">save</span>
                            Save
                          </Button>
                        )}
                      </Col>
                      <OverlayDrawer
                        title={"Logs"}
                        open={showDrawer}
                        onClose={handleCloseDrawer}
                        placement="bottom"
                      >
                        <DataTable
                          headers={STAKEHOLDER_CLINIC_ADDRESS}
                          rows={clinicLogs}
                          isLogTable={true}
                        />
                      </OverlayDrawer>
                    </Row>
                  </>
                ),
              },
            ])}
          </>
        )}
        <Modal show={showModal} onHide={handleCloseModal}>
          {/* <Modal.Header closeButton>
                    <Modal.Title>Confirm Cancellation</Modal.Title>
                  </Modal.Header> */}
          <Modal.Body className="fw-bold text-left modelheading">
            <div>Are you sure you want to cancel the form?</div>
            <div style={{ fontWeight: "300" }}>
              {" "}
              Any unsaved data will be lost.
            </div>
          </Modal.Body>
          <Modal.Footer className="border-top d-flex justify-content-end bg-light ">
            <Button
              variant="outline-info"
              className="d-flex align-items-center"
              onClick={handleCloseModal}
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>
            <Button
              variant="primary"
              className="ms-3 d-flex align-items-center"
              onClick={handleConfirmCancel}
            >
              <span className="material-icons mx-1">check</span> Confirm
            </Button>
          </Modal.Footer>
        </Modal>

        {!showForm && (
          <>
            {AccosiatedHospitalAccordion([
              {
                title: (
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <h3 className="mb-0">Associated Location List</h3>
                    <div className="d-flex align-items-center mx-2">
                      <h5 className="mb-0" style={{ fontSize: "15px" }}>
                        {contactName}
                      </h5>
                      <Badge pill bg="primary" className="ms-2 primary-badge">
                        {clinicDetails.length}
                      </Badge>
                    </div>
                  </div>
                ),
                content: (
                  <>
                    {
                      <div className="d-flex justify-content-between mb-3 mt-1">
                        {/* Left side: contactName and Badge */}
                        <div className="d-flex align-items-center mt-2">
                          <h3 className="mr-2">List</h3>
                        </div>

                        {!showForm && editContact && (
                          <div className="d-flex align-items-center">
                            {clinicDetails?.length > 0 && (
                              <Button
                                variant="outline"
                                className="d-flex align-items-center btn-text-border p-1 me-2"
                                onClick={() => {
                                  handleMapAction(stakeholdercontactid);
                                }}
                              >
                                <img
                                  src="/map.png"
                                  alt="map"
                                  style={{ width: "30px", height: "23px" }}
                                />
                              </Button>
                            )}

                            <Button
                              className="btn btn-primary d-flex align-items-center"
                              onClick={handleAddClinic}
                            >
                              <span className="material-icons mx-1">add</span>{" "}
                              Add
                            </Button>
                          </div>
                        )}

                        {/* Right side: Form.Check */}
                      </div>
                    }

                    {showPreviousClinic && (
                      <DataTable
                        headers={STAKEHOLDERS_CLINIC_CONTACT}
                        rows={clinicDetails}
                        onAction={(clinic) => handleEdit(clinic)}
                        onDownloadAction={handleSingleMapAction}
                      />
                    )}
                  </>
                ),
              },
            ])}
          </>
        )}

        {/* {activeTab === "clinic" && (
          <Row className="mb-3">
            <Col sm={6} className="d-flex justify-content-start mb-2">
              {!showForm && (
                <button
                  type="button"
                  className="btn d-flex align-items-center btn-text-border"
                  onClick={closeContactForm}
                >
                  <span className="material-icons mr-2">arrow_back</span>Back
                </button>
              )}
            </Col>
          </Row>
        )} */}
      </Container>
      <Snackbar
        open={snackbarOpen}
        message={snackbarMessage}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />
    </>
  );
};

export default AssociatedClinicForm;
